import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Tabs, H1, Loader } from '@itds/elements/index.js';

import General from './General';
import ModalFactors from './modal_factors/List';
import Bands from './bands/List';
import HealthCategories from './health_categories/List';
import TableRates from './table_rates/List';
import Riders from './riders/List';
import Formulas from './formulas/List';
import QuoteRates from './quote_rates/List';
import QuoteRatesEdit from './quote_rates/Edit';
import ImportCsv from './Import';
import Investments from './investments/Investments';
import FeesAndExpenses from './fees_and_expenses/FeesAndExpenses';

import Api from '@carrier/utils/Api';

const Show = () => {
  const navigate = useNavigate();
  const params = useParams();
  const hash = window.location.hash;

  const [version, setVersion] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDataVersion();
  }, []);

  const loadDataVersion = () => {
    setLoading(true);
    Api.loadDataVersion(params.version_id).then(({ data }) => {
      setVersion(data);

      setLoading(false);
    });
  };

  const tabs = [
    {
      label: 'General',
      to: ' ',
      isActive:
        hash.slice(-1) === `${params.version_id}`.slice(-1) || hash.slice(-1) === '/'.slice(-1)
    }
  ];

  if (version) {
    tabs.push(
      {
        label: 'Formulas',
        to: 'premium_formulas',
        isActive: window.location.hash.includes('premium_formulas')
      },
      {
        label: 'Quote Rates',
        to: 'quote_rates',
        isActive: window.location.hash.includes('quote_rates')
      },
      {
        label: 'Modal Factors',
        to: 'modal_factors',
        isActive: window.location.hash.includes('modal_factors')
      },
      {
        label: 'Bands',
        to: 'bands',
        isActive: window.location.hash.includes('bands')
      },
      {
        label: 'Health Categories',
        to: 'health_categories',
        isActive: window.location.hash.includes('health_categories')
      },
      {
        label: 'Table Rates',
        to: 'table_rates',
        isActive: window.location.hash.includes('table_rates')
      },
      {
        label: 'Riders',
        to: 'life_rider_rates',
        isActive: window.location.hash.includes('life_rider_rates')
      },
      {
        label: 'Fees and Expenses',
        to: 'fees_and_expenses',
        isActive: window.location.hash.includes('fees_and_expenses')
      },
      {
        label: 'Investments',
        to: 'investments',
        isActive: window.location.hash.includes('investments')
      },
      {
        label: 'Import CSV',
        to: 'import_csv',
        isActive: window.location.hash.includes('import_csv')
      }
    );
  }

  const props = { loadDataVersion, version };

  return loading ? (
    <Loader />
  ) : (
    <>
      <H1>{`Version ${params.version_id}`}</H1>
      <Breadcrumbs
        crumbs={[
          {
            label: 'Life Quotes',
            onClick: navigate.bind(null, `/carriers/${params.id}/life_quotes`)
          }
        ]}
        current={`Version ${params.version_id}`}
      />

      <div style={{ display: 'flex', margin: '0 -20px' }}>
        <Tabs tabs={tabs} vertical={true} width={130} />

        <div style={{ flex: 1, marginLeft: 40 }}>
          <Routes>
            <Route element={<General {...props} />} index={true} />
            <Route element={<ModalFactors {...props} />} path='modal_factors' />
            <Route element={<Bands {...props} />} path='bands' />
            <Route element={<HealthCategories {...props} />} path='health_categories' />
            <Route element={<TableRates {...props} />} path='table_rates' />
            <Route element={<Riders {...props} />} path='life_rider_rates' />
            <Route element={<FeesAndExpenses {...props} />} path='fees_and_expenses' />
            <Route element={<Investments {...props} />} path='investments' />
            <Route element={<Formulas {...props} />} path='premium_formulas' />
            <Route element={<QuoteRates {...props} />} path='quote_rates' />
            <Route element={<QuoteRatesEdit {...props} />} path='quote_rates/:rate_id/*' />
            <Route element={<ImportCsv {...props} />} path='import_csv' />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Show;
